import { uniqBy } from 'lodash';

/**
 * ページネーションで全イベントを取得する
 * @param {Function} fetchPage - (params) => Promise<{ events, last_evaluated }>
 * @param {Object} initialParams - 初回リクエストのパラメータ（toは自動設定、limitのデフォルトは100）
 * @param {Object} [options]
 * @param {AbortSignal} [options.signal] - AbortSignal
 * @returns {Promise<Array>} 重複除去済みの全イベント
 */
export async function fetchAllPages(fetchPage, initialParams, { signal } = {}) {
  const allEvents = [];
  let currentParams = { limit: 100, ...initialParams };

  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (signal?.aborted) break;

    // eslint-disable-next-line no-await-in-loop
    const response = await fetchPage(currentParams);
    allEvents.push(...(response.events || []));

    if (response.last_evaluated == null) break;

    currentParams = { ...currentParams, to: response.last_evaluated };
  }

  // to境界が包含的な場合に同一タイムスタンプのイベントが重複するため除去
  return uniqBy(allEvents, 'id');
}
